import StatEditor from "../../organisms/StatEditor";

const UpdateStat = () => {
  return <StatEditor headText="Stat 수정하기↩️" isEdit={true} />;
};

export default UpdateStat;
